import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=758bc364&scoped=true&"
import script from "./noticeDetail.vue?vue&type=script&lang=ts&"
export * from "./noticeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./noticeDetail.vue?vue&type=style&index=0&id=758bc364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758bc364",
  null
  
)

export default component.exports